import http from '@/utils/http';

export default {
	// 获取订单列表 (V2)
	list: (data) => {
		return http({ url: '/api/admin/v2/order/list', data }).then(r => r);
	},
};